import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import LoadingSpinner from "../../Controls/LoadingSpinner/LoadingSpinner";
import LoadingXeroxSpinner from "../../Controls/LoadingSpinner/XeroxLoadingSpinner";
import "./RpdUpload.css";
import Header from "../../../Shared/Header/Default/Herader";
import XeroxHeader from "../../../Shared/Header/Xerox/XeroxHeader";
import XeroxFooter from "../../../Shared/Footer/Xerox/XeroxFooter";
import DefaultFooter from "../../../Shared/Footer/Default/Footer";
import Alert from "../../Controls/Alerts/Alerts";

function RpdUpload() {
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [localDocumentId, setLocalDocumentId] = useState("");
  const [data, setData] = useState("");
  const [fileName, setFileName] = useState("");
  const [openLoader, setOpenLoader] = useState(false);

  const { documentId } = useParams();
  const { typeId } = useParams();

  const [Reader_DocumentID, setReader_DocumentID] = useState("");
  const [Reader_EmailAdress, setReader_EmailAdress] = useState("");
  const [Reader_VerificationCode, setReader_VerificationCode] = useState("");
  const [Reader_VerificationCode_Header, setReader_VerificationCode_Header] =
    useState("");
  const [Reader_Authorize, setReader_Authorize] = useState("");
  const [Reader_VerificationCode_Message, setReader_VerificationCode_Message] =
    useState("");
  const [Reader_ClickHere, setReader_ClickHere] = useState("");
  const [Reader_AuthorizeFailure, setReader_AuthorizeFailure] = useState("");
  const [Reader_GetVerificationCode, setReader_GetVerificationCode] =
    useState("");
  const [
    Reader_VerificationCode_Instruction,
    setReader_VerificationCode_Instruction,
  ] = useState("");
  const [
    Reader_VerificationCode_Remember,
    setReader_VerificationCode_Remember,
  ] = useState("");
  const [Reader_PleaseGoBack, setReader_PleaseGoBack] = useState("");
  const [Reader_Submit, setReader_Submit] = useState("");
  const [Reader_ActualSize, setReader_ActualSize] = useState("");
  const [Reader_FitPage, setReader_FitPage] = useState("");
  const [Reader_FullWidth, setReader_FullWidth] = useState("");
  const [Reader_DistributionList, setReader_DistributionList] = useState("");
  const [Reader_SideNote, setReader_SideNote] = useState("");
  const [Reader_ReplyToOwner, setReader_ReplyToOwner] = useState("");
  const [Reader_Print, setReader_Print] = useState("");
  const [Reader_Zoom, setReader_Zoom] = useState("");
  const [Reader_EnterYourEmailAddress, setReader_EnterYourEmailAddress] =
    useState("");
  const [Reader_Email, setReader_Email] = useState("");
  const [Reader_Passcode, setReader_Passcode] = useState("");
  const [Reader_OK, setReader_OK] = useState("");
  const [Reader_Getpasscode, setReader_Getpasscode] = useState("");
  const [Reader_GetPasscode, setReader_GetPasscode] = useState("");
  const [
    Reader_EnterYourEmailAddressCode,
    setReader_EnterYourEmailAddressCode,
  ] = useState("");
  const [
    Reader_EnterYourEmailAddressXerox,
    setReader_EnterYourEmailAddressXerox,
  ] = useState("");
  const [Reader_Cancel, setReader_Cancel] = useState("");
  const [Reader_DocumentExpired, setReader_DocumentExpired] = useState("");
  const [Reader_FailedVerifyCodeEmail, setReader_FailedVerifyCodeEmail] =
    useState("");
  const [Reader_Continue, setReader_Continue] = useState("");
  const [Reader_GeneralTermsFooter, setReader_GeneralTermsFooter] =
    useState("");
  const [Reader_GeneralTerms, setReader_GeneralTerms] = useState("");
  const [Reader_Patent, setReader_Patent] = useState("");
  const [Reader_CheckYourEmail, setReader_CheckYourEmail] = useState("");
  const [Reader_APasscodeEmailed, setReader_APasscodeEmailed] = useState("");
  const [Reader_AVerificationCodeEmailed, setReader_AVerificationCodeEmailed] =
    useState("");
  const [Reader_TryAgain, setReader_TryAgain] = useState("");
  const [Reader_DocumentRestrictedAccess, setReader_DocumentRestrictedAccess] =
    useState("");
  const [Reader_ReachedMaximumViews, setReader_ReachedMaximumViews] =
    useState("");
  const [
    Reader_DocumentIsNoLongerAvailable,
    setReader_DocumentIsNoLongerAvailable,
  ] = useState("");
  const [
    Reader_InactivityYourSessionWillEnd,
    setReader_InactivityYourSessionWillEnd,
  ] = useState("");
  const [Reader_Minutes, setReader_Minutes] = useState("");
  const [Reader_Seconds, setReader_Seconds] = useState("");
  const [Reader_SessionTimedOut, setReader_SessionTimedOut] = useState("");
  const [Reader_YouHaveBeenInactive, setReader_YouHaveBeenInactive] =
    useState("");
  const [Reader_ContinueReadingDocument, setReader_ContinueReadingDocument] =
    useState("");
  const [
    Reader_PrintingDocumentIsNotPermitted,
    setReader_PrintingDocumentIsNotPermitted,
  ] = useState("");
  const [Reader_ConfirmYourVote, setReader_ConfirmYourVote] = useState("");
  const [Reader_OnlyVoteOnce, setReader_OnlyVoteOnce] = useState("");
  const [Reader_Like, setReader_Like] = useState("");
  const [Reader_Dislike, setReader_Dislike] = useState("");
  const [Reader_Voting, setReader_Voting] = useState("");
  const [Reader_ProtectedDocument, setReader_ProtectedDocument] = useState("");
  const [Reader_ProtectedDocumentAccess, setReader_ProtectedDocumentAccess] =
    useState("");
  const [Reader_AllRightsReserved, setReader_AllRightsReserved] = useState("");
  const [Reader_Terms, setReader_Terms] = useState("");
  const [
    Reader_DocumentServerUnavailable,
    setReader_DocumentServerUnavailable,
  ] = useState("");
  const [
    Reader_InternetConnectionRequired,
    setReader_InternetConnectionRequired,
  ] = useState("");
  const [
    Reader_EnteredEmailIsNotReadersList,
    setReader_EnteredEmailIsNotReadersList,
  ] = useState("");
  const [Reader_FailedSendVerifyCode, setReader_FailedSendVerifyCode] =
    useState("");

  const [Reader_DocName, setReader_DocName] = useState("");
  const [Reader_ID, setReader_ID] = useState("");
  const [Reader_EnterEmailGetPasscode, setReader_EnterEmailGetPasscode] =
    useState("");
  const [Reader_PleaseEnterSubject, setReader_PleaseEnterSubject] =
    useState("");
  const [Reader_EmailSuccessfullySent, setReader_EmailSuccessfullySent] =
    useState("");
  const [Reader_DigitalRightsManagement, setReader_DigitalRightsManagement] =
    useState("");
  const [Reader_ProtectedDocumentViewer, setReader_ProtectedDocumentViewer] =
    useState("");
  const [Reader_ViewDistributionList, setReader_ViewDistributionList] =
    useState("");
  const [Reader_UsersList, setReader_UsersList] = useState("");
  const [Reader_ViewSideNote, setReader_ViewSideNote] = useState("");
  const [Reader_NoteFrom, setReader_NoteFrom] = useState("");
  const [Reader_ReplyToDocument, setReader_ReplyToDocument] = useState("");
  const [Reader_ClickToPrint, setReader_ClickToPrint] = useState("");
  const [Reader_Send, setReader_Send] = useState("");
  const [Reader_Message, setReader_Message] = useState("");
  const [Reader_Subject, setReader_Subject] = useState("");
  const [Reader_ToAddress, setReader_ToAddress] = useState("");
  const [Reader_YouWillLoggedIn, setReader_YouWillLoggedIn] = useState("");
  const [Reader_ClickToVote, setReader_ClickToVote] = useState("");
  const [Reader_DocumentHasNoAccess, setReader_DocumentHasNoAccess] =
    useState("");
  const [Reader_AccessDocument, setReader_AccessDocument] = useState("");
  const [
    Reader_SessionExpiredAccessDocument,
    setReader_SessionExpiredAccessDocument,
  ] = useState("");
  const [Reader_PleaseTryAgain, setReader_PleaseTryAgain] = useState("");
  const [Reader_CheckYourConnection, setReader_CheckYourConnection] =
    useState("");
  const [Reader_LegalNotices, setReader_LegalNotices] = useState("");
  const [Reader_ClickServiceLevelTerms, setReader_ClickServiceLevelTerms] =
    useState("");
  const [Reader_OtherService, setReader_OtherService] = useState("");
  const [Reader_YourDocumentadressAcess, setReader_YourDocumentadressAcess] =
    useState("");
  const [Reader_ReadMore, setReader_ReadMore] = useState("");
  const [Reader_InternetConnectProblem, setReader_InternetConnectProblem] =
    useState("");
  const [
    Reader_ConnectivityReauthenticate,
    setReader_ConnectivityReauthenticate,
  ] = useState("");
  const [Reader_BotInfoMessage, setReader_BotInfoMessage] = useState("");
  const [Reader_BlockMessage, setReader_BlockMessage] = useState("");
  const [Reader_robot, setReader_robot] = useState("");
  const [Reader_BotVerifiedMessage, setReader_BotVerifiedMessage] =
    useState("");
  const [Reader_Botverified, setReader_Botverified] = useState("");
  const [Reader_UserVerificationFailure, setReader_UserVerificationFailure] =
    useState("");
  const [Reader_ClickGetPasscode, setReader_ClickGetPasscode] = useState("");
  const[Reader_AuthenticatingPleaseWait,setReader_AuthenticatingPleaseWait]=useState("");
  const [Reader_LoadingPleaseWait,setReader_LoadingPleaseWait] = useState("");
  useEffect(() => {
    getLanguageTranslations();
  });
  function fileSelectionClick(event) {
    event.target.value = null;
    setLocalDocumentId("");
    setData("");
  }
  function fileSelection(event, source = 0) {
    setFileName("");
    var selectedFiles;
    if (event.target != undefined)
      selectedFiles = Array.prototype.slice.call(event.target.files);
    else selectedFiles = event;
    var validationSucess = true;
    if (selectedFiles.length > 0) {
      for (let index = 0; index < selectedFiles.length; index++) {
        const objFile = selectedFiles[index];
        if (
          "html".indexOf(
            objFile.name
              .split(".")
              [objFile.name.split(".").length - 1].toLowerCase()
          ) == -1
        ) {
          document.getElementById("imgFile").value = null;
          setAlertMsg("Please upload the valid RPD file.");
          setAlertType("warning");
          if (validationSucess) validationSucess = false;
        }
      }
      if (validationSucess) {
        setFileName(selectedFiles[0].name);
        const reader = new FileReader();
        reader.onload = async (e) => {
          const fileText = e.target.result;
          const lines = fileText.split("\n");
          lines.map((item) => {
            if (item.indexOf("const documentId =") > -1) {
              const tempDocId = item
                .replace("const documentId =", "")
                .replace('";', "")
                .replaceAll('"', "")
                .replace("\r", "")
                .replace(";", "")
                .trim();
              if (tempDocId == documentId) {
                setLocalDocumentId(tempDocId);
              } else {
                setAlertMsg("Please upload the valid RPD file.");
                setAlertType("warning");
                setFileName("");
              }
              console.log(item);
            } else if (item.indexOf("const data =") > -1) {
              const tempData = item
                .replace("const data =", "")
                .replace('";', "")
                .replaceAll('"', "")
                .replace(";\r", "")
                .trim();
              if (tempData != "" && tempData != null && tempData != undefined) {
                setData(tempData);
              } else {
                setAlertMsg("Please upload the valid RPD file.");
                setAlertType("warning");
                setFileName("");
              }

              console.log(item);
            }
          });
          console.log(fileText);
        };
        reader.readAsText(selectedFiles[0]);
      }
    } else {
      setLocalDocumentId("");
      setData("");
      setFileName("");
    }
  }
  function handleOnContinue() {
    if (localDocumentId == documentId && data != "") {
      setOpenLoader(true);
      let browserName = getBrowserName();
      var url = `${process.env.REACT_APP_API}/loaddocument/${localDocumentId}`;
      var rpdInfo = {
        id: localDocumentId,
        email: "",
        recipientId: "",
        data: data,
        ip: "",
        client: browserName,
      };
      fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(rpdInfo),
      })
        .then((response) => {
          console.log(response);
          const url = response.url;
          window.open(url, "_self");
        })
        .catch((error) => {
          console.log(error);
          setAlertMsg("Please upload the valid RPD file.");
          setAlertType("warning");
          setOpenLoader(false);
          console.log("Document read error");
        });
    } else {
      setAlertMsg("Please upload the valid RPD file.");
      setAlertType("warning");
    }
  }
  useEffect(() => {
    setTimeout(
      () => {
        setAlertMsg("");
        setAlertType("");
      },
      5000 //)
    );
  }, [alertType]);
  function getBrowserName() {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edg)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  }

  async function getLanguageTranslations() {
    const browserlanguage = window.navigator.language;
    const url = `${process.env.REACT_APP_API}/docs/languagetranslations/${documentId}/${browserlanguage}`;
    let json;
    try {
      var res = await fetch(url);
      json = await res.json();
      //console.log(json);
      //setLanguageTranslations(json.data);
      json.data.forEach((element) => {
        if (element.id === "2AC6EFF9-AF8B-4D36-8ABC-0A24B1C56F56")
          setReader_DocumentID(element.description);
        else if (element.id === "9BA629FE-2BA0-4740-89DC-167FCD3CA4C4")
          setReader_EmailAdress(element.description);
        else if (element.id === "3B344AE3-080C-4DFF-B17F-177BCB8D6A15")
          setReader_VerificationCode(element.description);
        else if (element.id === "8CA84CC8-46EE-4009-8EE0-1A9E11571EC8")
          setReader_VerificationCode_Header(element.description);
        else if (element.id === "F07FC5A9-C71D-4E63-911D-255E1544F3EB")
          setReader_Authorize(element.description);
        else if (element.id === "A4598B68-CC37-4B4D-9502-2A839C2C4865")
          setReader_VerificationCode_Message(element.description);
        else if (element.id === "7E85F861-F0E2-4BEC-92C4-2AEFF225FD6D")
          setReader_ClickHere(element.description);
        else if (element.id === "BF02D851-9481-4215-8EDD-2C4F1D1A14F5")
          setReader_AuthorizeFailure(element.description);
        else if (element.id === "B9272BCA-CFE7-4AA6-A530-30F2CC8377C2")
          setReader_GetVerificationCode(element.description);
        else if (element.id === "ECFD0FAA-B485-4499-9966-3A60FAB1ACE5")
          setReader_VerificationCode_Instruction(element.description);
        else if (element.id === "21E54828-A57B-4935-BBD5-40F08BD6F130")
          setReader_VerificationCode_Remember(element.description);
        else if (element.id === "BF69DF0D-8FF5-4555-AEC6-447F223E3AD6")
          setReader_PleaseGoBack(element.description);
        else if (element.id === "998BBBEF-9B6E-437A-80DC-56621DCED16D")
          setReader_Submit(element.description);
        else if (element.id === "5C20C8C9-C580-43A4-9E18-577A1F4E431C")
          setReader_ActualSize(element.description);
        else if (element.id === "8BCEBAA5-21F8-4D04-89D4-5A76836CB327")
          setReader_FitPage(element.description);
        else if (element.id === "294EBBB5-D0FA-42B8-B3AD-5F549463AAFD")
          setReader_FullWidth(element.description);
        else if (element.id === "BFE1787E-D04C-494C-A9E5-62496FA3FE08")
          setReader_DistributionList(element.description);
        else if (element.id === "AA313936-D9D9-408B-BBDB-6A8CE6CABB08")
          setReader_SideNote(element.description);
        else if (element.id === "7F73F129-096E-4BBA-B731-7A189872F835")
          setReader_ReplyToOwner(element.description);
        else if (element.id === "326A65C1-89D3-4554-ADAD-7B7E9B08E42C")
          setReader_Print(element.description);
        else if (element.id === "2FDC29C8-1A0D-4EED-9385-7F8CDFBB6A0F")
          setReader_Zoom(element.description);
        else if (element.id === "AE91A15B-35AF-480E-9250-8A65A062A596")
          setReader_EnterYourEmailAddress(element.description);
        else if (element.id === "B0C2990F-CDE0-45BE-B7DC-8C9B52338536")
          setReader_Email(element.description);
        else if (element.id === "6AB42951-6546-44B6-9750-C94B8BC3FA95")
          setReader_Passcode(element.description);
        else if (element.id === "442CE6A9-22AF-408A-A2AA-92EE577999A7")
          setReader_OK(element.description);
        else if (element.id === "B6785E69-9416-47A2-BDFA-9537E6A60591")
          setReader_Getpasscode(element.description);
        else if (element.id === "7754F0CA-053D-4203-9261-9A8D4BE56746")
          setReader_GetPasscode(element.description);
        else if (element.id === "818E8449-D5EE-4820-A646-9AC8D1D4F984")
          setReader_EnterYourEmailAddressCode(element.description);
        else if (element.id === "73D789E4-518B-41E5-AB1D-29FB252C960D")
          setReader_EnterYourEmailAddressXerox(element.description);
        else if (element.id === "DC458BAF-A9A8-403A-913A-A7C7C417A578")
          setReader_Cancel(element.description);
        else if (element.id === "434DDE98-2BB2-4A7C-82DE-AB6D6DEE9E7B")
          setReader_DocumentExpired(element.description);
        else if (element.id === "BBB2A9AA-0CBB-4175-B827-AC3FAF91B20C")
          setReader_FailedVerifyCodeEmail(element.description);
        else if (element.id === "B5EBC09A-28B3-4F66-8C8A-AD479D9B33B1")
          setReader_Continue(element.description);
        else if (element.id === "A43B773D-45DD-4968-809E-AE3271A639B3")
          setReader_GeneralTermsFooter(element.description);
        else if (element.id === "C920E4EB-129F-4EDC-BE19-B1CA133E0A19")
          setReader_GeneralTerms(element.description);
        else if (element.id === "674C0F1F-6EA4-443A-BD38-B47030C2ADA9")
          setReader_Patent(element.description);
        else if (element.id === "6F6B09DC-D705-4F70-A5AD-BA539115C23F")
          setReader_CheckYourEmail(element.description);
        else if (element.id === "1E0B6C7D-24EB-4697-8F00-CB3B3EECC1EE")
          setReader_APasscodeEmailed(element.description);
        else if (element.id === "809D3F1D-D2E6-475D-BEAB-CE7A6795C147")
          setReader_AVerificationCodeEmailed(element.description);
        else if (element.id === "3387D8D0-BDDB-4FA5-BE71-DBADEC20A0D4")
          setReader_TryAgain(element.description);
        else if (element.id === "AD9099E6-C2C1-480E-96F4-DC148642A783")
          setReader_DocumentRestrictedAccess(element.description);
        else if (element.id === "D22EFEBA-D89A-49E8-B544-DF728B2EC62C")
          setReader_ReachedMaximumViews(element.description);
        else if (element.id === "0FCF576E-DB5C-4246-B05F-E88215C69731")
          setReader_DocumentIsNoLongerAvailable(element.description);
        else if (element.id === "697A33A8-5735-4064-9866-E95832CC8303")
          setReader_InactivityYourSessionWillEnd(element.description);
        else if (element.id === "33903FCD-2591-469E-8891-E9B6F0746E3B")
          setReader_Minutes(element.description);
        else if (element.id === "12BCE010-F096-41B5-AE4F-EA98B2310538")
          setReader_Seconds(element.description);
        else if (element.id === "F84C536A-E172-4C14-B827-F06DC17E31D0")
          setReader_SessionTimedOut(element.description);
        else if (element.id === "1A9D7565-3DEB-4AF1-A60E-F5B08F62C834")
          setReader_YouHaveBeenInactive(element.description);
        else if (element.id === "817258A6-5338-4508-8733-F6437E942CBD")
          setReader_ContinueReadingDocument(element.description);
        else if (element.id === "FFDF3914-4CC6-4C02-A6D2-FC05F2A375F7")
          setReader_PrintingDocumentIsNotPermitted(element.description);
        else if (element.id === "27FF1441-6850-4601-B2DD-075D3AD01AEE")
          setReader_ConfirmYourVote(element.description);
        else if (element.id === "771A386D-B1F0-485C-B448-1D340209D580")
          setReader_OnlyVoteOnce(element.description);
        else if (element.id === "3341B4F5-4B0F-4BB1-A04F-46CFB98C803F")
          setReader_Like(element.description);
        else if (element.id === "CA3DB143-B23C-4351-B635-5E636C37664C")
          setReader_Dislike(element.description);
        else if (element.id === "E06FF01E-F57C-4337-94E5-986B31AB1D41")
          setReader_Voting(element.description);
        else if (element.id === "E9D32EC4-BFC1-49E0-9A11-5657B5AD4987")
          setReader_ProtectedDocumentAccess(element.description);
        else if (element.id === "007CF6B5-9AED-4956-A5E8-2D27F40795F9")
          setReader_ProtectedDocument(element.description);
        else if (element.id === "EEC944B7-CF89-4073-AAB2-38C5CD4C388C")
          setReader_AllRightsReserved(element.description);
        else if (element.id === "53708ED8-B8C6-4246-AB81-76F49FAC7E1C")
          setReader_Terms(element.description);
        else if (element.id === "AB232AED-8FB4-4E72-A550-DC57477EA1BE")
          setReader_DocumentServerUnavailable(element.description);
        else if (element.id === "977B4401-07E3-4848-870E-D7519A89BE0A")
          setReader_InternetConnectionRequired(element.description);
        else if (element.id === "A46D6AA3-7989-468F-85FE-AA9CA637A63A")
          setReader_EnteredEmailIsNotReadersList(element.description);
        else if (element.id === "D4FE0525-1829-48FE-87F7-D248053B5BF8")
          setReader_FailedSendVerifyCode(element.description);
        else if (element.id === "A399DFA9-C65E-40CC-A51B-7D3825270DB6")
          setReader_UserVerificationFailure(element.description);
        else if (element.id === "01464BDE-1F06-4CE4-B382-0D12FD415573")
          setReader_DocName(element.description);
        else if (element.id === "0198A1C3-A616-4383-9CA1-2B686E7B2161")
          setReader_ID(element.description);
        else if (element.id === "B1B1DD59-8DE0-4F34-914D-3BC9BF7C549A")
          setReader_EnterEmailGetPasscode(element.description);
        else if (element.id === "4D24E110-C95C-44DC-8DE0-586EEFD43901")
          setReader_PleaseEnterSubject(element.description);
        else if (element.id === "55F7F90F-5079-44D9-80C6-75E5CA0F3D8E")
          setReader_EmailSuccessfullySent(element.description);
        else if (element.id === "2B5CD1B8-E2C1-40FE-8657-81297F664F97")
          setReader_DigitalRightsManagement(element.description);
        else if (element.id === "384088DF-3A77-4AE7-9B85-2349394EFC30")
          setReader_ProtectedDocumentViewer(element.description);
        else if (element.id === "BCE385E2-E768-479E-8A28-7D90B153347E")
          setReader_ViewDistributionList(element.description);
        else if (element.id === "549961D1-C11B-4EF6-BFFC-8DC5BB995463")
          setReader_UsersList(element.description);
        else if (element.id === "F4CE40B3-2391-4A0B-BBB9-930710845A68")
          setReader_ViewSideNote(element.description);
        else if (element.id === "56B9CC7C-747E-420E-A5ED-B3F1C0A73D3B")
          setReader_NoteFrom(element.description);
        else if (element.id === "F8109066-3DEF-4FD3-A4A3-C6170D9D1CF8")
          setReader_ReplyToDocument(element.description);
        else if (element.id === "3C7C0F84-FC5E-416A-9E6B-110606DBE2DF")
          setReader_ClickToPrint(element.description);
        else if (element.id === "BA8DC442-BB68-4D4F-978F-64DE3B71D467")
          setReader_Send(element.description);
        else if (element.id === "EF11C8AF-E646-493F-9016-583861FF6008")
          setReader_Message(element.description);
        else if (element.id === "C1988359-42CB-41A2-8336-C7767AAE9406")
          setReader_Subject(element.description);
        else if (element.id === "4E086CF8-AAD1-4717-8CA4-E3C22EFC6256")
          setReader_ToAddress(element.description);
        else if (element.id === "39265EFF-9C1B-49D3-98BA-7110FA4AEB62")
          setReader_YouWillLoggedIn(element.description);
        else if (element.id === "CCC0FADA-9CD5-4BFD-BAEB-7EE9B9677DF1")
          setReader_ClickToVote(element.description);
        else if (element.id === "3D2F2837-9063-40CB-AF53-5E7790373EA1")
          setReader_DocumentHasNoAccess(element.description);
        else if (element.id === "0F8665A9-F7F3-4D07-8F64-E0F0576079D0")
          setReader_AccessDocument(element.description);
        else if (element.id === "F99602CF-AF87-4DE1-A20B-E82A064F1B51")
          setReader_SessionExpiredAccessDocument(element.description);
        else if (element.id === "8B569962-71C7-48A6-BDD0-43C37B489D91")
          setReader_PleaseTryAgain(element.description);
        else if (element.id === "5CA9B16D-46A7-43E9-9B3D-9076CB4C18B9")
          setReader_CheckYourConnection(element.description);
        else if (element.id === "C24DB5B6-951E-4E47-AEE1-A401FE85A7C3")
          setReader_LegalNotices(element.description);
        else if (element.id === "511A78A4-02CB-4EF0-A05C-3A8FC1EB92A7")
          setReader_ClickServiceLevelTerms(element.description);
        else if (element.id === "0C6DC977-FFCA-45BD-83DA-CD11AC5B7E6B")
          setReader_OtherService(element.description);
        else if (element.id === "57061912-dd57-46f2-8f39-3b01a75b2fd6")
          setReader_YourDocumentadressAcess(element.description);
        else if (element.id === "67732020-983b-49d8-bc69-f27790bf009e")
          setReader_ReadMore(element.description);
        else if (element.id === "4ddea558-4a3f-43b8-bdb2-d69df1c2162c")
          setReader_BotInfoMessage(element.description);
        else if (element.id === "47dd41f8-d61f-42ad-a0be-38195c694d01")
          setReader_robot(element.description);
        else if (element.id === "4d9606ee-3ddd-46cb-8444-b656e4b217ad")
          setReader_Botverified(element.description);
        else if (element.id === "d46741cd-dc5d-4ba5-984f-2c4dec6989dd")
          setReader_BotVerifiedMessage(element.description);
        else if (element.id === "6B574532-AAD2-4356-86FC-5C2F27E90FFE")
          setReader_InternetConnectProblem(element.description);
        else if (element.id === "555ADB9D-8867-4455-8BB7-85EA9BA0C2BB")
          setReader_ConnectivityReauthenticate(element.description);
        else if (element.id === "a6bcc85d-c1b3-43c8-8424-4db0dc30ce18")
          setReader_ClickGetPasscode(element.description);
        else if (element.id === "ad4c892f-dd09-44e7-893a-09e59cfa22b5")
          setReader_BlockMessage(element.description);
        else if(element.id ==="73243072-681e-41af-b4dc-bfe19afb7631")
          setReader_AuthenticatingPleaseWait(element.description);
          else if (element.id === "c77447de-ae4a-42a9-9f82-f8bf21ed8d57")
            setReader_LoadingPleaseWait(element.description);
      });
    } catch (error) {
      console.log(error);
      return () => {};
    }
  }
  return (
    <div className="dvIos">
      {openLoader ? (
        typeId === "1" ? (
          <LoadingXeroxSpinner />
        ) : (
          <div className="spinerAuth-text">
            <LoadingSpinner  authenticatingMsg={Reader_LoadingPleaseWait}/>
          </div>
        )
      ) : null}
      {typeId === "1" ? (
        <XeroxHeader
          Reader_ProtectedDocument={Reader_ProtectedDocument}
        ></XeroxHeader>
      ) : (
        <Header
          Reader_ProtectedDocumentAccess={Reader_ProtectedDocumentAccess}
        ></Header>
      )}
      <div>
        <div className="customAlert">
          <Alert
            alertType={alertType}
            alertMsg={alertMsg}
            className="alerthist"
          ></Alert>
        </div>

        {typeId === "1" ? (
          <main className="RobotoFont form-signin">
            <div className="user_card">
              <div className="d-flex justify-content-center">
                <img
                  src="data:image/png;base64,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"
                  alt=""
                  className="check1 mb-4"
                ></img>
              </div>
              <h4
                className="d-flex justify-content-center"
                style={{ textAlign: "center", padding: "0px 5px 10px 5px", color:"#0a4148" }}
              >
                Please upload the protected document and click on View Document.
              </h4>
              <div
                className="drag multi-drag upload form-control ms-2 "
                style={{
                  display: "grid",
                  border: "dashed 2px grey",
                  backgroundColor: "#f1f1e0ab",
                }}
              >
                <p className="d-flex flex-column justify-content-center font-w600 font-14 mb-0">
                  <div className="row row-height">
                    <div className="d-flex flex-column align-items-center justify-content-center col-md-12 ps-1 pe-2 pt-12Moz">
                      <input
                        type="file"
                        id="imgFile"
                        title="Click to select file"
                        value=""
                        onClick={(e) => fileSelectionClick(e)}
                        onChange={(e) => fileSelection(e)}
                      ></input>
                      <span
                        className="light underline"
                        style={{
                          padding: "40px",
                          cursor: "pointer",
                          textDecoration: "underline",
                          color:"#0a4148"
                        }}
                      >
                        {" "}
                        Click to select file
                      </span>
                    </div>
                    <div
                      className="col-md-7 col-sm-12 ps-1 pe-2 d-none"
                      style={{
                        borderLeft: "2px dashed rgba(67, 94, 190, 0.5)",
                      }}
                    >
                      <div className="file-scrollbar d-none d-md-block"></div>
                    </div>
                  </div>
                </p>
              </div>
              <div className="RobotoFont d-flex justify-content-center  m-2">
                <span className="light underline" style={{ cursor: "pointer" }}>
                  {fileName}
                </span>
              </div>
              <div className="RobotoFont d-flex justify-content-center">
                <button className="btn btn-dark" onClick={handleOnContinue} style={{backgroundColor:"#0a4148"}}>
                  View Document
                </button>
              </div>
              <form>
                <div className="RobotoFont d-flex justify-content-center login_container"></div>
              </form>
            </div>
          </main>
        ) : (
          <main className="rpdFont form-signin">
            <div className="user_card">
              <div className="d-flex justify-content-center">
                <img
                  src="data:image/png;base64,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"
                  alt=""
                  className="check1 mb-4"
                ></img>
              </div>
              <h4
                className="d-flex justify-content-center"
                style={{ textAlign: "center", padding: "0px 5px 10px 5px" }}
              >
                Please upload the protected document and click on View Document.
              </h4>
              <div
                className="drag multi-drag upload form-control ms-2 "
                style={{
                  display: "grid",
                  border: "dashed 2px grey",
                  backgroundColor: "#f1f1e0ab",
                }}
              >
                <p className="d-flex flex-column justify-content-center font-w600 font-14 mb-0">
                  {/* <label
                  name="imgFile"
                  className="attache-title d-flex align-items-center justify-content-center mb-0 font-20 font-w600 text-lightblack"
                >

                  Attachment
                  <div className="d-none d-md-block"></div>
                </label> */}
                  <div className="row row-height">
                    <div className="d-flex flex-column align-items-center justify-content-center col-md-12 ps-1 pe-2 pt-12Moz">
                      <input
                        type="file"
                        id="imgFile"
                        title="Click to select file"
                        value=""
                        onClick={(e) => fileSelectionClick(e)}
                        onChange={(e) => fileSelection(e)}
                      ></input>
                      <span
                        className="light underline"
                        style={{
                          padding: "40px",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                      >
                        {" "}
                        Click to select file
                      </span>
                    </div>
                    <div
                      className="col-md-7 col-sm-12 ps-1 pe-2 d-none"
                      style={{
                        borderLeft: "2px dashed rgba(67, 94, 190, 0.5)",
                      }}
                    >
                      <div className="file-scrollbar d-none d-md-block"></div>
                    </div>
                  </div>
                </p>
              </div>
              <div className="rpdFont d-flex justify-content-center  m-2">
                <span className="light underline" style={{ cursor: "pointer" }}>
                  {fileName}
                </span>
              </div>
              <div className="rpdFont d-flex justify-content-center">
                <button className="btn btn-dark" onClick={handleOnContinue}  >
                  View Document
                </button>
              </div>
              <form>
                <div className="rpdFont d-flex justify-content-center login_container"></div>
              </form>
            </div>
          </main>
        )}
        <div></div>
      </div>
      {typeId === "1" ? (
        <XeroxFooter
          Reader_AllRightsReserved={Reader_AllRightsReserved}
          Reader_Terms={Reader_Terms}
          class="rpduploadclass"
        ></XeroxFooter>
      ) : (
        <DefaultFooter
          Reader_GeneralTermsFooter={Reader_GeneralTermsFooter}
          Reader_LegalNotices={Reader_LegalNotices}
          Reader_ClickServiceLevelTerms={Reader_ClickServiceLevelTerms}
          Reader_Patent={Reader_Patent}
          Reader_OtherService={Reader_OtherService}
        ></DefaultFooter>
      )}
    </div>
  );
}
export default RpdUpload;
